import axiosInstance from 'api/axiosInstance';
import { customDateParserForGuard } from 'containers/pages/CANguard/utils/customDateParserForGuard';
import { mapFrontEndStatusToBackendStatus } from 'containers/pages/CANguard/utils/mapPatrolStatus';
interface UpdatePatrolReturn {
	startTime: Date;
	updatedEndTime: Date;
}
export const updatePatrol = async (
	commentListID: number,
	updatedCheckpoints: PatrolCheckpoint[],
	generalNotesText: string | null,
	generalNotesStatus: PatrolGeneralStatus | null,
	updateEndTime: boolean = true,
): Promise<UpdatePatrolReturn> => {
	let url = '/Project/WebService/CANDispatch.asmx/SubmitPatrol';
	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}
	// Map the updated checkpoints to the format the API expects
	const updatedCheckpointsPayload = updatedCheckpoints.map((checkpoint) => {
		return {
			CheckpointID: checkpoint.CheckpointID,
			Time: checkpoint.Time ?? null,
			DateTime: checkpoint.DateTime ?? null, 
			Comment: checkpoint.Comment,
			SelectedStatusID: checkpoint.SelectedStatusID,
			SelectedDropdownIDs: checkpoint.SelectedDropdownIDs,
		};
	});
	

	const data = {
		payload: {
			CommentListID: commentListID,
			UpdatedCheckpoints: updatedCheckpointsPayload,
			UpdatedComment: generalNotesText,
			UpdatedStatus: mapFrontEndStatusToBackendStatus(generalNotesStatus),
			updateEndTime: updateEndTime,
		},
	};
	try {
		const response = await axiosInstance.post(url, data);
		if (response.status !== 200) {
			throw new Error(
				`Error updating patrols: Status ${response.status}`,
			);
		}

		if (!response.data || !response.data.d || !response.data.d[0]) {
			throw new Error('Unexpected response format');
		}

		const parsedData = JSON.parse(response.data.d);
		const returnValue: UpdatePatrolReturn = {
			startTime: customDateParserForGuard(parsedData[0].start_date),
			updatedEndTime: customDateParserForGuard(parsedData[0].end_date),
		};

		return returnValue;
	} catch (error) {
		console.error('updatePatrol error:', error);
		throw error;
	}
};
